import { render, staticRenderFns } from "./TrackingPageTemplateForm.vue?vue&type=template&id=724e1d7a&scoped=true&"
import script from "./TrackingPageTemplateForm.vue?vue&type=script&lang=js&"
export * from "./TrackingPageTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./TrackingPageTemplateForm.vue?vue&type=style&index=0&id=724e1d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e1d7a",
  null
  
)

export default component.exports